interface NavigationArrowDownIconProperties {
  isActive: boolean;
}

const NavigationArrowDownIcon = ({ isActive }: NavigationArrowDownIconProperties) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'>
      <path
        d='M4.99999 6L-4.29138e-07 7.94465e-08L10 9.53674e-07L4.99999 6Z'
        fill={isActive ? 'white' : '#8B5CF6'}
      />
    </svg>
  );
};

export default NavigationArrowDownIcon;
